import React from "react";
class Breadcrumb extends React.Component {
  render() {
    return<div className="breadcrumb-area mb-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="breadcrumb-content">
                            <ul className="nav">
                                <li><a href="/index">Home</a></li>
                                {this.props.group ? <li><a href={this.props.url}>{this.props.head}</a></li> : <li>{this.props.head}</li>}
                                {this.props.group ? <li>{this.props.group}</li>:""}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            }
        }
        
        export default Breadcrumb;